import React, { memo } from "react"
import { List, Link } from "@material-ui/core"
import { Trans } from "@lingui/macro"
import { SubNavigation } from "@components/SubNavigation/SubNavigation"
import { SubNavigationListItem } from "@components/SubNavigation/SubNavigationListItem"
import { toId } from "@utils/data"

// Memoized TOC item component
const TocItem = memo(({ content, scrollTo }) => (
  <SubNavigationListItem
    key={toId(content)}
    text={content.content}
    to={`#${content.id}`}
    component={Link}
    onClick={(event) => scrollTo(event, toId(content))}
  />
))
TocItem.displayName = "TocItem"

const SubmenuArticle = ({ scrollTo, contentTableOfContents }) => {
  if (contentTableOfContents.length === 0) {
    return null
  }

  return (
    <SubNavigation
      title={
        <span className="notranslate">
          <Trans>Contents</Trans>
        </span>
      }
    >
      <List>
        {contentTableOfContents.map((c) => (
          <TocItem key={toId(c)} content={c} scrollTo={scrollTo} />
        ))}
      </List>
    </SubNavigation>
  )
}

export { SubmenuArticle }
